<template>
	<component
		data-component="icon"
		:is="getSvg"
		:data-colour="colour"
		:data-icon="icon"
		:alt="icon"
	/>
</template>

<script>

	/* eslint-disable vue/no-unused-components */

	import { pascalCase }         from 'change-case';
	import ArrowLeft              from '@/assets/icons/arrow-left.svg?inline';
	import ArrowRight             from '@/assets/icons/arrow-right.svg?inline';
	import Book                   from '@/assets/icons/book.svg?inline';
	import Burger                 from '@/assets/icons/burger.svg?inline';
	import CaretDown              from '@/assets/icons/caret-down.svg?inline';
	import CaretUp                from '@/assets/icons/caret-up.svg?inline';
	import ChevronLeft            from '@/assets/icons/chevron-left.svg?inline';
	import ChevronLeftDouble      from '@/assets/icons/chevron-left-double.svg?inline';
	import ChevronRight           from '@/assets/icons/chevron-right.svg?inline';
	import ChevronRightDouble     from '@/assets/icons/chevron-right-double.svg?inline';
	import Club                   from '@/assets/icons/club.svg?inline';
	import ClubWithoutPadding     from '@/assets/icons/club-without-padding.svg?inline';
	import Courses                from '@/assets/icons/courses.svg?inline';
	import CrossCircle            from '@/assets/icons/cross-circle.svg?inline';
	import Cross                  from '@/assets/icons/cross.svg?inline';
	import Dealer                 from '@/assets/icons/dealer.svg?inline';
	import Diamond                from '@/assets/icons/diamond.svg?inline';
	import DiamondWithoutPadding  from '@/assets/icons/diamond-without-padding.svg?inline';
	import Document               from '@/assets/icons/document.svg?inline';
	import EditAlt                from '@/assets/icons/edit-alt.svg?inline';
	import Edit                   from '@/assets/icons/edit.svg?inline';
	import Equal                  from '@/assets/icons/equal.svg?inline';
	import Exclamation            from '@/assets/icons/exclamation.svg?inline';
	import Ff                     from '@/assets/icons/ff.svg?inline';
	import FlipCard               from '@/assets/icons/flip-card.svg?inline';
	import Gamepad                from '@/assets/icons/gamepad.svg?inline';
	import Heart                  from '@/assets/icons/heart.svg?inline';
	import HeartWithoutPadding    from '@/assets/icons/heart-without-padding.svg?inline';
	import Hide                   from '@/assets/icons/hide.svg?inline';
	import Highlight              from '@/assets/icons/highlight.svg?inline';
	import Home                   from '@/assets/icons/home.svg?inline';
	import Info                   from '@/assets/icons/info.svg?inline';
	import Medal                  from '@/assets/icons/medal.svg?inline';
	import Menu                   from '@/assets/icons/menu.svg?inline';
	import Plane                  from '@/assets/icons/plane.svg?inline';
	import Play                   from '@/assets/icons/play.svg?inline';
	import Plus                   from '@/assets/icons/plus.svg?inline';
	import Reorder                from '@/assets/icons/reorder.svg?inline';
	import RotateBack             from '@/assets/icons/rotate-back.svg?inline';
	import RotateForward          from '@/assets/icons/rotate-forward.svg?inline';
	import Rw                     from '@/assets/icons/rw.svg?inline';
	import Search                 from '@/assets/icons/search.svg?inline';
	import Settings               from '@/assets/icons/settings.svg?inline';
	import Ship                   from '@/assets/icons/ship.svg?inline';
	import Show                   from '@/assets/icons/show.svg?inline';
	import Spade                  from '@/assets/icons/spade.svg?inline';
	import SpadeWithoutPadding    from '@/assets/icons/spade-without-padding.svg?inline';
	import Spinner                from '@/assets/icons/spinner.svg?inline';
	import Star                   from '@/assets/icons/star.svg?inline';
	import User                   from '@/assets/icons/user.svg?inline';
	import Users                  from '@/assets/icons/users.svg?inline';
	import UserCircle             from '@/assets/icons/user-circle.svg?inline';
	import UserGroup              from '@/assets/icons/user-group.svg?inline';
	import Warning                from '@/assets/icons/warning.svg?inline';
	import Check                  from '@/assets/icons/check.svg?inline';
	import Question               from '@/assets/icons/question.svg?inline';
	import FullscreenOpen         from '@/assets/icons/fullscreen-open.svg?inline';
	import FullscreenClose        from '@/assets/icons/fullscreen-close.svg?inline';
	import Stop                   from '@/assets/icons/stop.svg?inline';
	import Pause                  from '@/assets/icons/pause.svg?inline';

	import V2ChevronDown          from '@/assets/icons/v2/chevron-down.svg?inline';
	import V2ChevronLeft          from '@/assets/icons/v2/chevron-left.svg?inline';
	import V2ImagePlaceholder     from '@/assets/icons/v2/image-placeholder.svg?inline';
	import V2BarPointer           from '@/assets/icons/v2/bar-pointer.svg?inline';
	import V2Book                 from '@/assets/icons/v2/book.svg?inline';
	import V2Shield               from '@/assets/icons/v2/shield.svg?inline';
	import V2LightingRound        from '@/assets/icons/v2/lighting-round.svg?inline';
	import V2FireRound            from '@/assets/icons/v2/fire-round.svg?inline';
	import V2Tick                 from '@/assets/icons/v2/tick.svg?inline';
	import V2Menu                 from '@/assets/icons/v2/menu.svg?inline';
	import V2Filter               from '@/assets/icons/v2/filter.svg?inline';
	import V2Cross                from '@/assets/icons/v2/cross.svg?inline';
	import V2Bookmark             from '@/assets/icons/v2/bookmark.svg?inline';
	import V2Teacher              from '@/assets/icons/v2/teacher.svg?inline';
	import V2Presentation         from '@/assets/icons/v2/presentation.svg?inline';
	import V2Go                   from '@/assets/icons/v2/go.svg?inline';
	import V2Video                from '@/assets/icons/v2/video.svg?inline';
	import V2Date                 from '@/assets/icons/v2/date.svg?inline';
	import V2Pdf                  from '@/assets/icons/v2/pdf.svg?inline';
	import V2Quiz                 from '@/assets/icons/v2/quiz.svg?inline';
	import V2Cards                from '@/assets/icons/v2/cards.svg?inline';
	import V2Clock                from '@/assets/icons/v2/clock.svg?inline';
	import V2Search               from '@/assets/icons/v2/search.svg?inline';
	import V2Videos               from '@/assets/icons/v2/videos.svg?inline';
	import V2Quizes               from '@/assets/icons/v2/quizes.svg?inline';
	import V2BookRound            from '@/assets/icons/v2/book-round.svg?inline';
	import V2VideoPlayer          from '@/assets/icons/v2/video-player.svg?inline';
	import V2VideoMini            from '@/assets/icons/v2/video-mini.svg?inline';
	import V2QuizMini             from '@/assets/icons/v2/quiz-mini.svg?inline';
	import V2Settings            from '@/assets/icons/v2/settings.svg?inline';
	import V2Error            from '@/assets/icons/v2/error.svg?inline';
	import V2HomeLogo      from '@/assets/icons/v2/home-logo.svg?inline';
	import V2Info      from '@/assets/icons/v2/info.svg?inline';
	import V2CorrectAnswer     from '@/assets/icons/v2/correct-answer.svg?inline';
	import V2IncorrectAnswer      from '@/assets/icons/v2/incorrect-answer.svg?inline';
	import V2BackgroundLogo     from '@/assets/icons/v2/background-logo.svg?inline';
	import V2DealSettings     from '@/assets/icons/v2/deal-settings.svg?inline';
	import V2Gameplay     from '@/assets/icons/v2/gameplay.svg?inline';
	import V2DealPlay     from '@/assets/icons/v2/deal-play.svg?inline';

	import V2StartVideo      from '@/assets/icons/v2/start-video.svg?inline';
	import V2StartStar      from '@/assets/icons/v2/start-star.svg?inline';
	import V2StartFire      from '@/assets/icons/v2/start-fire.svg?inline';
	import V2StartCards      from '@/assets/icons/v2/start-cards.svg?inline';

	import V2LessonPresentation   from '@/assets/icons/v2/lesson/presentation.svg?inline';
	import V2LessonQuiz           from '@/assets/icons/v2/lesson/quiz.svg?inline';
	import V2LessonVideo          from '@/assets/icons/v2/lesson/video.svg?inline';
	import V2LessonCompleted      from '@/assets/icons/v2/lesson/completed.svg?inline';

	import V2AboutInfo   from '@/assets/icons/v2/about/info.svg?inline';
	import V2AboutLearning           from '@/assets/icons/v2/about/learning.svg?inline';
	import V2AboutPlaying          from '@/assets/icons/v2/about/playing.svg?inline';
	import V2AboutTeaching      from '@/assets/icons/v2/about/teaching.svg?inline';
	import V2AboutTerms      from '@/assets/icons/v2/about/terms.svg?inline';

	import V2LightBulb from '@/assets/icons/v2/lightbulb.svg?inline';
	import V2Paperclip from '@/assets/icons/v2/paperclip.svg?inline';
	import V2ListUl from '@/assets/icons/v2/list-ul.svg?inline';
	import V2Rocket from '@/assets/icons/v2/rocket.svg?inline';
	import V2FileFilled from '@/assets/icons/v2/file-filled.svg?inline';

	import V2Copy from '@/assets/icons/v2/copy.svg?inline';
	import V2GoogleIcon from '@/assets/icons/v2/google-icon.svg?inline';

	export default {
		components: {
			ArrowLeft,
			ArrowRight,
			Book,
			Burger,
			CaretDown,
			CaretUp,
			ChevronLeft,
			ChevronLeftDouble,
			ChevronRight,
			ChevronRightDouble,
			Club,
			ClubWithoutPadding,
			Courses,
			CrossCircle,
			Cross,
			Dealer,
			Diamond,
			DiamondWithoutPadding,
			Document,
			EditAlt,
			Edit,
			Equal,
			Exclamation,
			Ff,
			FlipCard,
			Gamepad,
			Heart,
			HeartWithoutPadding,
			Hide,
			Highlight,
			Home,
			Info,
			Medal,
			Menu,
			Plane,
			Play,
			Plus,
			Reorder,
			RotateBack,
			RotateForward,
			Rw,
			Search,
			Settings,
			Ship,
			Show,
			Spade,
			SpadeWithoutPadding,
			Spinner,
			Star,
			User,
			Users,
			UserCircle,
			UserGroup,
			Warning,
			Question,
			Check,
			FullscreenOpen,
			FullscreenClose,
			Stop,
			Pause,

			V2ChevronDown,
			V2ChevronLeft,
			V2ImagePlaceholder,
			V2BarPointer,
			V2Book,
			V2Shield,
			V2LightingRound,
			V2FireRound,
			V2Tick,
			V2Menu,
			V2Filter,
			V2Cross,
			V2Bookmark,
			V2Teacher,
			V2Presentation,
			V2Go,
			V2Video,
			V2Date,
			V2Pdf,
			V2Quiz,
			V2Cards,
			V2Clock,
			V2Search,
			V2Videos,
			V2Quizes,
			V2BookRound,
			V2VideoPlayer,
			V2VideoMini,
			V2QuizMini,
			V2Settings,
			V2Error,
			V2HomeLogo,
			V2StartVideo,
			V2StartCards,
			V2StartFire,
			V2StartStar,
			V2Info,
			V2CorrectAnswer,
			V2IncorrectAnswer,
			V2DealSettings,
			V2Gameplay,
			V2DealPlay,

			V2LessonPresentation,
			V2LessonQuiz,
			V2LessonVideo,
			V2LessonCompleted,

			V2AboutInfo,
			V2AboutLearning,
			V2AboutPlaying,
			V2AboutTeaching,
			V2AboutTerms,
			V2BackgroundLogo,

			V2LightBulb,
			V2Paperclip,
			V2ListUl,
			V2Rocket,
			V2FileFilled,

			V2Copy,
			V2GoogleIcon
		},

		props: {
			icon: {
				type: [String, Boolean],
				default: 'box'
			},
			colour: {
				type: String,
				default: 'text'
			}
		},
		computed: {
			getSvg () {
				if (!this.icon) {
					return false;
				}
				return pascalCase(this.icon);
			}
		}
	};

</script>

<style lang="scss" scoped>

	[data-component='icon'] {
		display:block;
		&[data-colour='black'] {
			* {
				fill: $c-brand-black !important;
			}
		}
		&[data-colour='red'] {
			* {
				fill: $c-brand-red !important;
			}
		}
		&[data-colour='blue'] {
			* {
				fill: $c-brand-blue !important;
			}
		}
		&[data-colour='green'] {
			* {
				fill: $c-brand-green !important;
			}
		}
		&[data-colour='orange'] {
			* {
				fill: $c-brand-orange !important;
			}
		}
		&[data-colour='blue-lighter-1'] {
			* {
				fill: $c-brand-blue-lighter-1 !important;
			}
		}
		&[data-colour='blue-lighter-2'] {
			* {
				fill: $c-brand-blue-lighter-2 !important;
			}
		}
		&[data-colour='blue-lighter-3'] {
			* {
				fill: $c-brand-blue-lighter-3 !important;
			}
		}
		&[data-colour='blue-lighter-4'] {
			* {
				fill: $c-brand-blue-lighter-4 !important;
			}
		}
		&[data-colour='grey'] {
			* {
				fill: $c-brand-grey !important;
			}
		}
		&[data-colour='grey-lighter-1'] {
			* {
				fill: $c-brand-grey-lighter-1 !important;
			}
		}
		&[data-colour='grey-lighter-2'] {
			* {
				fill: $c-brand-grey-lighter-2 !important;
			}
		}
		&[data-colour='grey-lighter-3'] {
			* {
				fill: $c-brand-grey-lighter-3 !important;
			}
		}
		&[data-colour='grey-lighter-4'] {
			* {
				fill: $c-brand-grey-lighter-4 !important;
			}
		}
		&[data-colour='text'] {
			* {
				fill: $c-text !important;
			}
		}
		&[data-colour='white'] {
			* {
				fill: $c-white !important;
			}
		}
		&[data-colour='yellow'] {
			* {
				fill: yellow !important;
			}
		}
    &[data-colour='dark-navy'] {
			* {
				fill: $c-dark-navy !important;
			}
		}
    &[data-colour='darkest-navy'] {
			* {
				fill: $c-darkest-navy !important;
			}
		}

    &[data-colour='medium-navy'] {
			* {
				fill: $c-medium-navy !important;
			}
		}

    &[data-colour='gray-d5'] {
			* {
				fill: $c-gray-d5 !important;
			}
		}
	}

</style>
